//types
export const ROCK_TYPE = 'MODEL/ROCK_TYPE';

//setter
export const setTypes = types => ({ type: ROCK_TYPE, types}) ;
